import {
   AiAssistantConfigurationQuery,
   AiAssistantConfigurationToggleCommand,
   RecordingInProgressFault,
} from '@dreryk/egabinet-ai-assistant-frontend-api';

import { refetchCqrsQuery, useCqrsCommand, UseCqrsCommandResult } from '@dreryk/command-query-react-common';
import { dispatchSnackbarNegativeEvent, dispatchSnackbarPositiveEvent } from '@dreryk/react-components';
import { commonTranslationKeys } from '@dreryk/react-common';

import { aiAssistantSettingsPanelTranslationKeys } from '../../translations';

import { AiAssistantSettingsFormBean } from './AiAssistantSettingsForm.types';

const t = aiAssistantSettingsPanelTranslationKeys;

type UseAiAssistantConfigurationToggleCommandOptions = Readonly<{
   onFailure: (parameters: AiAssistantSettingsFormBean) => void;
}>;

export const useAiAssistantConfigurationToggleCommand = (
   options: UseAiAssistantConfigurationToggleCommandOptions
): UseCqrsCommandResult<void, AiAssistantSettingsFormBean> => {
   return useCqrsCommand<void, AiAssistantSettingsFormBean, RecordingInProgressFault>(
      (parameters) => {
         const command = new AiAssistantConfigurationToggleCommand();
         command.enabled = parameters.enabled;
         return command;
      },
      {
         onSuccess: (__, parameters) => {
            dispatchSnackbarPositiveEvent(parameters.enabled ? t.saveOn : t.saveOff);
            refetchCqrsQuery(AiAssistantConfigurationQuery);
         },
         onFault: {
            'egabinet-ai-assistant-frontend-api:RecordingInProgressFault': (__, parameters) => {
               dispatchSnackbarNegativeEvent(t.recordingInProgressFault);
               options.onFailure(parameters);
            },
         },
         onUnexpectedError: (__, parameters) => {
            dispatchSnackbarNegativeEvent(commonTranslationKeys.unexpectedErrorHasOccurred);
            options.onFailure(parameters);
         },
      }
   );
};
